import { useEffect, useState } from 'react'

import { getCountdownValues } from '@src/utils/time.utils'

export const useCountdown = (targetDate: string | number | Date) => {
  const countDownDate = new Date(targetDate).getTime()

  const [countDown, setCountDown] = useState(countDownDate - new Date().getTime())

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(countDownDate - new Date().getTime())
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [countDownDate])

  return getCountdownValues(countDown)
}
